import Link from './Link';


Link.install = function(Vue) {
  Vue.component(Link.name, Link);
};

export default Link;
